// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1CRq5","header":"ClearentDisclaimer_header__T3dhO","inner":"ClearentDisclaimer_inner__1g3NY"};